import { render, staticRenderFns } from "./RadioDesigner.vue?vue&type=template&id=ffd48d96&scoped=true&"
import script from "./RadioDesigner.vue?vue&type=script&lang=js&"
export * from "./RadioDesigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffd48d96",
  null
  
)

export default component.exports